import script from "./Data.vue?vue&type=script&setup=true&lang=js"
export * from "./Data.vue?vue&type=script&setup=true&lang=js"

import "./Data.vue?vue&type=style&index=0&id=1ccde2a0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ccde2a0"]])

export default __exports__